import { SpeakingSessionRoomDto, SpeakingSlotStatus } from 'api/planning';
import { useScrollDrag, useScrollClick } from 'hooks';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { speakingSessionStore } from 'store';

type Props = {
  speakingSessionRooms: SpeakingSessionRoomDto[];
};

export const useRooms = ({ speakingSessionRooms }: Props) => {
  const dispatch = useDispatch();
  const { ref } = useScrollDrag<HTMLDivElement>('main-speaking-slots-slider');
  const { onClickLeft, onClickRight } = useScrollClick(24, 8, 'main-speaking-slots-slider');

  useEffect(() => {
    const slotCounts = speakingSessionRooms.map((x) => {
      const speakingSlots = x.roomStructures.flatMap((x) => x.speakingSlots);

      return {
        roomId: x.id,
        counts: {
          available: speakingSlots
            .filter((slot) => slot.status === SpeakingSlotStatus.Available)
            .reduce((sum, slot) => sum + slot.availableCapacity, 0),
          awaitingApproval: speakingSlots.filter(
            (slot) => slot.status === SpeakingSlotStatus.AwaitingApproval
          ).length,
          rejected: speakingSlots.filter((slot) => slot.status === SpeakingSlotStatus.Rejected)
            .length,
          booked: speakingSlots.reduce(
            (sum, slot) => sum + (slot.plannedCapacity - slot.availableCapacity),
            0
          ),
        },
      };
    });

    dispatch(speakingSessionStore.actions.setRoomSlotCounts(slotCounts));
  }, [dispatch, speakingSessionRooms]);

  return { ref, onClickLeft, onClickRight };
};
